import { useTranslation } from '@lt/localization';
import React from 'react';
import {
  PAYLATE_WARNING,
  PAYLATE_WARNING_AMOUNT,
} from 'src/store/payment/constants';
import styled from 'styled-components';
import type { PaymentMethod } from 'checkout/types/payment';

const baseCls = 'checkout-payment';

interface PaylatePaymentProps {
  item: PaymentMethod;
}

const PaylatePayment = ({ item }: PaylatePaymentProps) => {
  const { t } = useTranslation();
  const {
    amount,
    additional_data: { pay_today, percent, period, info },
  } = item;

  return (
    <div className={`${baseCls}__paylate`}>
      {amount > PAYLATE_WARNING_AMOUNT && (
        <div className={`${baseCls}__paylate__warning`}>{PAYLATE_WARNING}</div>
      )}

      {[pay_today, percent, period].map(({ title, description }) => (
        <div className={`${baseCls}__paylate__row`} key={null}>
          <span className={`${baseCls}__paylate__title`}>{title}</span>

          <span className={`${baseCls}__paylate__description`}>
            {description}
          </span>
        </div>
      ))}

      <div
        className={`${baseCls}__paylate__additional`}
        dangerouslySetInnerHTML={{ __html: info.description }}
      />
      <a
        className={`${baseCls}__paylate__link functional-button lt-link`}
        title={t('checkout.payment.detail')}
        href="//promo.level.travel/paylate"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('checkout.payment.detail')}
      </a>
      <StyledPayment className={`${baseCls}__paylate__sub`}>
        {t('checkout.payment.paylate')}
        <div className={`${baseCls}__paylate__icon`} />
      </StyledPayment>
    </div>
  );
};

const StyledPayment = styled.div`
  white-space: pre-line;
`;

export default PaylatePayment;
